var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReputationComments(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 13C6.34328 13 6.19298 12.9377 6.08216 12.8269C5.97135 12.7161 5.90909 12.5658 5.90909 12.4091V10.6364H3.54545C3.23202 10.6364 2.93142 10.5119 2.70978 10.2902C2.48815 10.0686 2.36364 9.76798 2.36364 9.45455V3.54545C2.36364 3.23202 2.48815 2.93142 2.70978 2.70978C2.93142 2.48815 3.23202 2.36364 3.54545 2.36364H11.8182C12.1316 2.36364 12.4322 2.48815 12.6539 2.70978C12.8755 2.93142 13 3.23202 13 3.54545V9.45455C13 9.76798 12.8755 10.0686 12.6539 10.2902C12.4322 10.5119 12.1316 10.6364 11.8182 10.6364H9.39545L7.20909 12.8286C7.09091 12.935 6.94909 13 6.79545 13H6.5ZM7.09091 9.45455V11.2745L8.91091 9.45455H11.8182V3.54545H3.54545V9.45455H7.09091ZM1.18182 8.27273H0V1.18182C0 0.86838 0.124513 0.56778 0.346147 0.346147C0.56778 0.124513 0.86838 0 1.18182 0H10.6364V1.18182H1.18182V8.27273ZM4.72727 4.72727H10.6364V5.90909H4.72727V4.72727ZM4.72727 7.09091H9.45455V8.27273H4.72727V7.09091Z",
    fill: "#234BA2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReputationComments);
export default __webpack_public_path__ + "static/media/reputation-comments.f857ab16013f91102aa9d5785f8763b3.svg";
export { ForwardRef as ReactComponent };